export const availabilitiesKey = ["availabilities"];
export const postsKey = ["posts"];
export const postKey = ["post"];
export const postCalendarRestrictionsKey = ["post-calendar-restrictions"];
export const postCalendarDatesKey = ["post-calendar-dates"];
export const collectionsKey = "collections";
export const blockedPhrasesKey = "blockedPhrases";
export const playlistsKey = "playlists";
export const playlistKey = "playlist";
